
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M429.581 307.019a24.436 24.436 0 00-32.3 12.284 154.821 154.821 0 01-279.667 6.033l13.84 6.162a24.437 24.437 0 1019.879-44.649l-64.315-28.634A24.437 24.437 0 0054.754 270.6l-28.635 64.313a24.437 24.437 0 1044.649 19.879l3.266-7.335A203.681 203.681 0 00256 459.645l3.551-.031a203.669 203.669 0 00182.315-120.292 24.438 24.438 0 00-12.285-32.303zM473.5 144.823a24.438 24.438 0 00-32.264 12.385l-3.266 7.335a203.685 203.685 0 00-367.085 6.494 24.437 24.437 0 1044.406 20.415 154.82 154.82 0 01279.1-4.788l-13.84-6.162a24.438 24.438 0 00-19.879 44.65L424.8 253.7l.117.052a24.435 24.435 0 0032.329-12.352l28.635-64.313a24.437 24.437 0 00-12.381-32.264z"}})])
          )
        }
      }
    